//1枚目
document.querySelector('.modal_section_coupon').addEventListener('click', function() {
    document.querySelector('.modal-content1').style.display = 'none';
    document.querySelector('.modal-content2').style.display = 'block';
  });

document.querySelector('.modal_section_point').addEventListener('click', function() {
    document.querySelector('.modal-content1').style.display = 'none';
    document.querySelector('.modal-content3').style.display = 'block';
  });

//2枚目
document.addEventListener('DOMContentLoaded', function () {
    var treadBtn = document.querySelector('.tread_btn');
    var myCouponBtn = document.querySelector('.my_coupon_btn');

    myCouponBtn.addEventListener('click', function () {
        document.querySelector('.tread_inner').style.display = 'none';
        document.querySelector('.my_coupon_inner').style.display = 'block';
      treadBtn.classList.remove('is-active');
      myCouponBtn.classList.add('is-active');
    });

    treadBtn.addEventListener('click', function () {
        document.querySelector('.my_coupon_inner').style.display = 'none';
        document.querySelector('.tread_inner').style.display = 'block';
        myCouponBtn.classList.remove('is-active');
        treadBtn.classList.add('is-active');
    });
  });

document.getElementById('back2-1').addEventListener('click', function() {
    // modal-content1を非表示にし、modal-content2を表示する
    document.querySelector('.modal-content2').style.display = 'none';
    document.querySelector('.modal-content1').style.display = 'block';
  });

//3枚目
document.getElementById('back3-1').addEventListener('click', function() {
    // modal-content1を非表示にし、modal-content2を表示する
    document.querySelector('.modal-content3').style.display = 'none';
    document.querySelector('.modal-content1').style.display = 'block';
  });

